import React from "react";
import Slider from "react-slick";

import Sri from "../Assets/srinath.png";
import Sakthi from "../Assets/Sakthivel.png";
import Shanthani from "../Assets/shanthini.jpg";
import Vicky from "../Assets/vignesh.jpg";
import Dhana from "../Assets/Dhana.jpg";
import Priya from "../Assets/Priyadharshini.jpg"
const TeamsPage = () => {
  const teamDetails = [
    {
      id: 1,
      name: "Dr. Midthe Vijayaragavan Srinath",
      designation: "Director / Academic Expert",
      profileImage: Sri,
      fbLink: "https://www.facebook.com/",
      twitterLink: "https://x.com/sakthisuji14?s=11",
      linkedin:
        "https://www.linkedin.com/in/sakthivel-selvamani-71a98126?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
      gitLink: "",
      details:
        "Expert in instructional design, e-learning, and academic consulting with 20+ years experience.",
    },
    {
      id: 2,
      name: "Sakthivel Selvamani",
      designation: "Director",
      profileImage: Sakthi,
      twitterLink: "https://www.twitter.com/",
      linkedin: "https://www.linkedin.com/",
      gitLink: "",
      details:
        "Leads product development and innovation across Sankara's software solutions.",
    },
    {
      id: 3,
      name: "Shanthini Anand",
      designation: "Director",
      profileImage: Shanthani,
      fbLink: "https://www.facebook.com/",
      twitterLink: "https://www.twitter.com/",
      linkedin: "https://www.linkedin.com/",
      gitLink: "",
      details:
        "Experienced in banking & software industries with strong leadership and operations expertise.",
    },
    {
      id: 4,
      name: "Vignesh Murugan",
      designation: "Project Lead",
      profileImage: Vicky,
      fbLink: "https://www.facebook.com/",
      twitterLink: "https://x.com/vigneshm1411998",
      linkedin:
        "https://www.linkedin.com/in/vignesh-m-64b674191?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      gitLink: "",
      details:
        "I lead our operations with confidence and a clear vision, ensuring everything moves forward seamlessly.",
    },
    {
      id: 5,
      name: "Dhanasekar Venkatesan",
      designation: "AWS Cloud Manager",
      profileImage: Dhana,
      fbLink: "https://www.facebook.com/",
      twitterLink: "https://www.twitter.com/",
      linkedin: "https://www.linkedin.com/in/dhanasekar-venkatesan-8b8571229/",
      // gitLink: "https://www.github.com/",
      details:
        "Expertise in cloud technologies and operational excellence makes him a valuable asset to the organization's growth and success.",
    },
    {
      id: 6,
      name: "Priyadharshini S",
      designation: "Cyber Security Analyst",
      profileImage:
       Priya,
      fbLink: "https://www.facebook.com/",
      twitterLink: "",
      linkedin: "https://www.linkedin.com/in/priyadharshini-sasikumar-aa2762357?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      // gitLink: "https://www.github.com/",
      details:
        "Specializes in threat detection, security audits, and implementing robust cybersecurity measures to protect organizational assets.",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      { breakpoint: 1300, settings: { slidesToShow: 3 } },
      { breakpoint: 950, settings: { slidesToShow: 2 } },
      { breakpoint: 630, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="team-area bg-f9f6f6" id="team">
      <div className="container">
        <div className="section-title">
          <h2>Our Awesome Team</h2>
          <div className="bar"></div>
          <p>Shaping Tomorrow with Innovation and Excellence.</p>
        </div>
      </div>
      <div className="swiper swiper-initialized swiper-horizontal team-slider swiper-backface-hidden">
        <div
          className="swiper-wrapper"
          style={{
            transform: "translate3d(0px, 0px, 0px)",
            transitionDuration: "0ms",
            height: "max-content",
          }}
        >
          <div
            className="carousel"
            style={{ width: "100%", overflow: "hidden" }}
          >
            <div
              className="carousel-inner"
              style={{
                display: "flex",
                height: "500px",
              }}
            >
              <Slider {...settings}>
                {teamDetails?.map((item) => (
                  <div
                    className="swiper-slide single-team team-container"
                    key={item.id}
                  >
                    <div className="team-image">
                      <img src={item.profileImage} alt={item.name} />
                    </div>
                    <div className="team-content">
                      <div className="team-info">
                        <h3>{item.name}</h3>
                        <span>{item.designation}</span>
                      </div>
                      <ul>
                        {item.fbLink?.trim() && (
                          <li>
                            <a
                              href={item.fbLink}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                              </svg>
                            </a>
                          </li>
                        )}

                        {item.twitterLink?.trim() && (
                          <li>
                            <a
                              href={item.twitterLink}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                              >
                                <path d="M18.244 2H21.5l-7.19 8.21L22.5 22h-6.48l-5.08-6.63L4.98 22H1.72l7.7-8.79L1.5 2h6.62l4.58 6.02L18.244 2zm-1.14 18h1.8L7.1 3.9H5.18l11.924 16.1z" />
                              </svg>
                            </a>
                          </li>
                        )}

                        {item.linkedin?.trim() && (
                          <li>
                            <a
                              href={item.linkedin}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                                <rect x="2" y="9" width="4" height="12"></rect>
                                <circle cx="4" cy="4" r="2"></circle>
                              </svg>
                            </a>
                          </li>
                        )}

                        {item.gitLink?.trim() && (
                          <li>
                            <a
                              href={item.gitLink}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <path d="M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z"></path>
                              </svg>
                            </a>
                          </li>
                        )}
                      </ul>
                      {item.details && <p>{item.details}</p>}
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamsPage;
// import Slider from "react-slick";
// import Sri from "../Assets/srinath.png";
// import Sakthi from "../Assets/Sakthivel.png";
// import Shanthani from "../Assets/shanthini.jpg";
// import Vicky from "../Assets/vignesh.jpg";

// const TeamsPage = () => {
//   const teamDetails = [
//     {
//       id: 1,
//       name: "Dr. MIDTHE VIJAYARAGAVAN SRINATH",
//       designation: "Director / Academic Expert",
//       profileImage: Sri,
//       fbLink: "",
//       twitterLink: "",
//       linkedin: "",
//       gitLink: "",
//       details:
//         "Expert in instructional design, e-learning, and academic consulting with 20+ years experience.",
//     },
//     {
//       id: 2,
//       name: "Sakthivel Selvamani",
//       designation: "Solutions Director",
//       profileImage: Sakthi,
//       fbLink: "",
//       twitterLink: "",
//       linkedin: "",
//       gitLink: "",
//       details:
//         "Leads product development and innovation across Sankara's software solutions.",
//     },
//     {
//       id: 3,
//       name: "Shanthini Anand",
//       designation: "Board Member",
//       profileImage: Shanthani,
//       fbLink: "",
//       twitterLink: "",
//       linkedin: "",
//       gitLink: "",
//       details:
//         "Experienced in banking & software industries with strong leadership and operations expertise.",
//     },
//     {
//       id: 4,
//       name: "Vignesh Murugan",
//       designation: "Project Manager",
//       profileImage: Vicky,
//       fbLink: "",
//       twitterLink: "",
//       linkedin: "",
//       gitLink: "",
//       details:
//         "Leads subscription-based products with focus on execution and team collaboration.",
//     },
//   ];

//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 1000,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 2000,
//     responsive: [
//       { breakpoint: 1300, settings: { slidesToShow: 3 } },
//       { breakpoint: 950, settings: { slidesToShow: 2 } },
//       { breakpoint: 630, settings: { slidesToShow: 1 } },
//     ],
//   };

//   return (
//     <div className="team-area bg-f9f6f6" id="team">
//       <div className="container">
//         <div className="section-title">
//           <h2>Our Awesome Team</h2>
//           <div className="bar"></div>
//           <p>Shaping Tomorrow with Innovation and Excellence.</p>
//         </div>
//       </div>
//       <div className="swiper swiper-initialized swiper-horizontal team-slider swiper-backface-hidden">
//         <div
//           className="swiper-wrapper"
//           style={{
//             transform: "translate3d(0px, 0px, 0px)",
//             transitionDuration: "0ms",
//             height: "max-content",
//           }}
//         >
//           <div className="carousel" style={{ width: "100%", overflow: "hidden" }}>
//             <div
//               className="carousel-inner"
//               style={{
//                 display: "flex",
//                 height: "430px",
//               }}
//             >
//               <Slider {...settings}>
//                 {teamDetails?.map((item) => (
//                   <div
//                     className="swiper-slide single-team team-container"
//                     key={item.id}
//                   >
//                     <div className="team-image">
//                       <img src={item.profileImage} alt="Team" />
//                     </div>
//                     <div className="team-content">
//                       <div className="team-info">
//                         <h3>{item.name}</h3>
//                         <span>{item.designation}</span>
//                       </div>
//                       <ul>
//                         {item.fbLink?.trim() && (
//                           <li>
//                             <a
//                               href={item.fbLink}
//                               target="_blank"
//                               rel="noreferrer"
//                             >
//                               <svg
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 width="24"
//                                 height="24"
//                                 viewBox="0 0 24 24"
//                                 fill="none"
//                                 stroke="currentColor"
//                                 strokeWidth="2"
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                               >
//                                 <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
//                               </svg>
//                             </a>
//                           </li>
//                         )}

//                         {item.twitterLink?.trim() && (
//                           <li>
//                             <a
//                               href={item.twitterLink}
//                               target="_blank"
//                               rel="noreferrer"
//                             >
//                               <svg
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 width="24"
//                                 height="24"
//                                 viewBox="0 0 24 24"
//                                 fill="none"
//                                 stroke="currentColor"
//                                 strokeWidth="2"
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                               >
//                                 <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>
//                               </svg>
//                             </a>
//                           </li>
//                         )}

//                         {item.linkedin?.trim() && (
//                           <li>
//                             <a
//                               href={item.linkedin}
//                               target="_blank"
//                               rel="noreferrer"
//                             >
//                               <svg
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 width="24"
//                                 height="24"
//                                 viewBox="0 0 24 24"
//                                 fill="none"
//                                 stroke="currentColor"
//                                 strokeWidth="2"
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                               >
//                                 <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
//                                 <rect x="2" y="9" width="4" height="12"></rect>
//                                 <circle cx="4" cy="4" r="2"></circle>
//                               </svg>
//                             </a>
//                           </li>
//                         )}

//                         {item.gitLink?.trim() && (
//                           <li>
//                             <a
//                               href={item.gitLink}
//                               target="_blank"
//                               rel="noreferrer"
//                             >
//                               <svg
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 width="24"
//                                 height="24"
//                                 viewBox="0 0 24 24"
//                                 fill="none"
//                                 stroke="currentColor"
//                                 strokeWidth="2"
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                               >
//                                 <path d="M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z"></path>
//                               </svg>
//                             </a>
//                           </li>
//                         )}
//                       </ul>
//                       {item.details && <p>{item.details}</p>}
//                     </div>
//                   </div>
//                 ))}
//               </Slider>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TeamsPage;
